import type { IFormxRepository, SubmissionUpdateInput } from '../repositories/IFormxRepository.js';

interface Deps { formxRepository: IFormxRepository; }

export function createUpdateFormxSubmissionUseCase({ formxRepository }: Deps) {
  return async function updateFormxSubmission(id: string, input: SubmissionUpdateInput): Promise<void> {
    return formxRepository.updateSubmissionWithValues(id, input);
  };
}
